// data/languages/Cote/categories/couleurs.ts

import { CategoryData } from '../../../../types/types';

export const couleurs: CategoryData = {
    // Couleurs vérifiées précédemment
    'ⲟⲩⲱⲃϣ (ouôbš)': {
        translation: 'Blanc',
        translationEn: 'White',
        illustration: '⚪'
    },
    'ⲕⲁⲙⲉ (kame)': {
        translation: 'Noir',
        translationEn: 'Black',
        illustration: '⚫'
    },
    'ⲕⲏⲙⲉ (kême)': {
        translation: 'Noir (variante)',
        translationEn: 'Black (variant)',
        illustration: '⚫'
    },

    // Couleurs ajoutées
    'ϣⲓⲗⲗⲟⲩ (šillou)': {
        translation: 'Jaune',
        translationEn: 'Yellow',
        illustration: '🟡'
    },
    'ϩⲏⲙ (hêm)': {
        translation: 'Rouge / Sang',
        translationEn: 'Red / Blood',
        illustration: '🔴'
    },
    'ⲧⲁϩⲓ (tahi)': {
        translation: 'Bleu',
        translationEn: 'Blue',
        illustration: '🔵'
    },
    'ⲙⲉⲗⲉϥ (melef)': {
        translation: 'Vert',
        translationEn: 'Green',
        illustration: '🟢'
    },
    'ⲛⲟⲩⲃ (noub)': {
        translation: 'Doré',
        translationEn: 'Golden',
        illustration: '🌟'
    },
    'ⲡⲟⲣⲫⲩⲣⲁ (porphyra)': {
        translation: 'Pourpre',
        translationEn: 'Purple',
        illustration: '🟣'
    },
};

export default couleurs;
